export const replyRecEdited = inResponseToMessageId => ({
  key: 'editReplyRecommendation',
  properties: {
    action: 'Clicks to edit reply recommendation',
    inResponseToMessageId,
    platform: 'Helpdesk'
  }
});
export const replyRecSent = inResponseToMessageId => ({
  key: 'sendReplyRecommendation',
  properties: {
    action: 'Clicks to send reply recommendation',
    inResponseToMessageId,
    platform: 'Helpdesk'
  }
});
export const replyRecSeen = inResponseToMessageId => ({
  key: 'renderReplyRecommendation',
  properties: {
    action: 'Systems displays reply recommendation',
    inResponseToMessageId,
    platform: 'Helpdesk'
  }
});